export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ae0ed5c2751e32e8d3262d750100abe7.jpg"
          alt="Electrical Infrastructure"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="absolute inset-0 z-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(0deg, transparent 24%, rgba(255, 255, 255, .05) 25%, rgba(255, 255, 255, .05) 26%, transparent 27%, transparent 74%, rgba(255, 255, 255, .05) 75%, rgba(255, 255, 255, .05) 76%, transparent 77%, transparent), linear-gradient(90deg, transparent 24%, rgba(255, 255, 255, .05) 25%, rgba(255, 255, 255, .05) 26%, transparent 27%, transparent 74%, rgba(255, 255, 255, .05) 75%, rgba(255, 255, 255, .05) 76%, transparent 77%, transparent)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-6xl md:text-7xl font-bold leading-tight">
                <div className="text-white">Reliable</div>
                <div className="bg-gradient-to-r from-sky-400 to-sky-600 bg-clip-text text-transparent">
                  Electrical Solutions
                </div>
                <div className="text-white font-semibold">You Can Trust</div>
              </h1>
              <div className="flex items-center gap-2">
                <span className="text-4xl">⚡</span>
              </div>
            </div>

            <p className="text-lg text-gray-200 max-w-xl leading-relaxed">
              Professional contracting services for residential, commercial & industrial projects
            </p>

            <div className="flex flex-wrap gap-4">
              <button 
                onClick={() => scrollToSection('projects')}
                className="px-8 py-4 bg-sky-500 text-white rounded-full font-medium hover:bg-sky-600 transition-all flex items-center gap-2 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                View Projects
                <i className="ri-arrow-right-line"></i>
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="px-8 py-4 border-2 border-sky-500 text-white rounded-full font-medium hover:bg-sky-500 transition-all whitespace-nowrap cursor-pointer"
              >
                Contact Us
              </button>
            </div>
          </div>

          <div className="relative hidden md:block">
            <div className="relative">
              <div className="absolute top-0 left-0 w-72 h-80 transform -rotate-3 z-30">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20electrical%20panel%20installation%20work%20showing%20modern%20circuit%20breaker%20panel%20with%20organized%20wiring%20and%20safety%20equipment%20close-up%20technical%20photography%20with%20clean%20industrial%20aesthetic%20featuring%20metallic%20components%20labeled%20switches%20and%20professional%20cable%20management%20shot%20with%20sharp%20focus%20on%20electrical%20components%20simple%20neutral%20background%20emphasizing%20precision%20and%20technical%20expertise&width=280&height=320&seq=hero-card-001&orientation=portrait"
                  alt="Electrical Panel Work"
                  className="w-full h-full object-cover rounded-2xl shadow-2xl"
                />
              </div>

              <div className="absolute bottom-0 right-0 w-96 h-[480px] transform rotate-2 z-10">
                <img
                  src="https://readdy.ai/api/search-image?query=electrical%20cable%20laying%20work%20in%20progress%20showing%20underground%20cable%20installation%20with%20workers%20handling%20heavy%20duty%20electrical%20cables%20in%20trench%20professional%20construction%20photography%20featuring%20organized%20cable%20management%20safety%20equipment%20and%20technical%20precision%20simple%20construction%20site%20background%20emphasizing%20scale%20and%20professional%20execution%20of%20infrastructure%20project&width=380&height=480&seq=hero-card-002&orientation=portrait"
                  alt="Cable Laying Work"
                  className="w-full h-full object-cover rounded-2xl shadow-2xl"
                />
              </div>

              <div className="absolute top-20 right-12 w-80 h-96 transform rotate-1 z-20">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20meter%20installation%20work%20showing%20modern%20digital%20electricity%20meter%20being%20installed%20by%20skilled%20technician%20close-up%20technical%20photography%20with%20focus%20on%20precision%20and%20safety%20featuring%20clean%20installation%20professional%20tools%20and%20proper%20wiring%20connections%20simple%20neutral%20background%20emphasizing%20technical%20expertise%20and%20attention%20to%20detail&width=320&height=360&seq=hero-card-003&orientation=portrait"
                  alt="Meter Installation"
                  className="w-full h-full object-cover rounded-2xl shadow-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
